import React, { Component } from 'react';
import * as Constants from '../../common/Global/constants';
import {getLocalStorageVariables,isEmptyVariable, isEmptyArray, hasFeatureAccess, handleTokenExpiry} from '../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import RegularDropdown from '../../common/DropdownMenus/RegularDropdown';
import {DialogSaveButton,TreeNodeCheckBox} from '../../common/Global/globalStyles.style';
import AddCityDialog from '../../common/DropdownMenus/addCityDropdownDialog'
import SelectGroupingDialog from './selectGrouping';
import AlertDialog from '../../common/AlertDialog';
import { AsyncPaginate } from 'react-select-async-paginate';

let userDetails = getLocalStorageVariables();
const unitTypePlaceholder = "Select Unit Type";
const functionPlaceholder = "Select Function";
const cityPlaceholderText = "Select City";
const unitGroupingPlaceholderText = "Select Grouping";

const FunctionTree = (props) => {

    return <div className="dialog-tree-structure">
        <div className="tree-node checkboxparent" style={{marginLeft:(props.level*40)+"px"}}>
            <span 
                onClick={()=>props.onClickNode(props.functionObj)}
                class="material-icons" style={{opacity:isEmptyArray(props.functionObj.children)?"0":"1"}}>
                {props.functionObj.isShowingChildren?"keyboard_arrow_down":"keyboard_arrow_right"}
            </span>
            <TreeNodeCheckBox
            themeSettings={props.themeSettings}>
                <input 
                    type="checkbox"
                    name={props.functionObj.functionId}
                    id={props.functionObj.functionId}
                    onChange={props.handleSelection}
                    checked={props.functionObj.isSelected?true:false}
                />
                <label for={props.functionObj.functionId} 
                style={{marginLeft:6}}>{props.functionObj.functionName}</label>
            </TreeNodeCheckBox>
            {/* <p for={props.functionObj.functionId}>{props.functionObj.functionName}</p> */}
        </div>

        {
            //Exit Condition
            props.functionObj.isShowingChildren &&
            props.getChildNodes(props.functionObj).map((child, idx)=>{
                let levelTemp = props.level + 1;
                return <FunctionTree 
                    functionObj = {child} 
                    getChildNodes = {props.getChildNodes}
                    level={levelTemp}
                    handleSelection={props.handleSelection}
                    onClickNode={props.onClickNode}
                    themeSettings={props.themeSettings}
                />
            })
        }
    </div>
}
class AddUnitDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,

            unitName:"",
            unitShortName:"",
            address1:"",
            address2:"",
            city:"Search City",
            pinCode:"",
            state:"",
            country:"Search Country",
            unitType:unitTypePlaceholder,
            unitTypeShortName:"",
            tagsMasterDD:[],
            tagsSelectedDD:[],
            formErrors:{},
            functionFormErr:{},

            showAddCityDialog: false,
            selectedGroupingObjArr: [],
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        }
        this.textInput = React.createRef();
        this.functionMapLocal = {};
        this.selectedFunctionObjArr = [];
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showAddUnitDialog){

            this.functionMapLocal = {};
            this.functionMapLocal = JSON.parse(JSON.stringify(this.props.functionsArr));

            let tagsMasterDD= !isEmptyVariable(this.props.functionsArr) ? this.props.functionsArr.map((item)=>({value:item.function,label:item.function})) : [];
            
            if(this.props.isEdit){
                //get the function ids and then change the function map
                //add isSelected and saveValue flags
                //functionList is in the format functionName:-:12,functionName:-:53
                //Retrieve the function id from above stirng and check the boxes
                //Also Open the parent dropdown

                var funcWithIdArr = [];
                if(!isEmptyVariable(this.props.editUnitItem.functionList)){
                    funcWithIdArr = this.props.editUnitItem.functionList.split(",");
                }

                let tagsSelectedDD = funcWithIdArr.map(funcItem => {
                    return {
                        value:funcItem,
                        label:funcItem
                    }
                })

                this.setState({
                    formErrors:{},
                    unitName:this.props.editUnitItem.unitName,
                    unitShortName:this.props.editUnitItem.unitShortName,
                    address1:this.props.editUnitItem.address1,
                    address2:this.props.editUnitItem.address2,
                    city:this.props.editUnitItem.city,
                    pinCode:this.props.editUnitItem.pinCode,
                    state:this.props.editUnitItem.state,
                    country:this.props.editUnitItem.country,
                    unitType:this.props.editUnitItem.unitTypeName,
                    unitTypeShortName:this.props.editUnitItem.unitType,
                    tagsSelectedDD:tagsSelectedDD,
                    tagsMasterDD:tagsMasterDD,
                    showAddCityDialog: false,
                    selectedGroupingObjArr: this.props.editUnitItem.selectedGroupingList
                },()=>{
                    this.textInput.current.focus();
                })
            }else{
                this.setState({
                    formErrors:{},
                    unitName:"",
                    unitShortName:"",
                    address1:"",
                    address2:"",
                    city:"Search City",
                    pinCode:"",
                    state:"",
                    country:"Search Country",
                    functionList:functionPlaceholder,
                    unitType:unitTypePlaceholder,
                    showAddCityDialog: false,
                    tagsMasterDD:tagsMasterDD,
                    tagsSelectedDD:[],
                    isEdit:false,
                    selectedGroupingObjArr: []
                },()=>{
                    this.textInput.current.focus();
                })
            }
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleTagChange = (newValueArr, actionMeta) => {
		this.setState({
            tagsSelectedDD: newValueArr,
        });
	};

    typeDropdownClick = (item) => {
        this.setState({
            unitType:item.name,
            unitTypeShortName:item.shortName
        })
    }
    
    onKeyBtnPress = (e) => {
        var code = e.keyCode || e.which;
        if(code === 13){
            this.handleSelectFuncDialogShow();
        }
    }

    handleSearchCityDialogClose = (selectedItem) => {

        if(!isEmptyVariable(selectedItem)){
            this.setState({
                city:selectedItem.city,
                state:selectedItem.state,
                country:selectedItem.country,
                showAddCityDialog:false,
            })
        }
        else{
            this.setState({
                showAddCityDialog: false,
            });
        }
	};

	showAddCityDialog = () => {
        if(!isEmptyVariable(this.state.city)){
            this.setState({
                showAddCityDialog: true,
                isEdit:true,
    
            });
        }
        else{
            this.setState({
                showAddCityDialog: true,
    
            });
        }
		
	};

    handleSelectGroupingDialogShow = () => {
        this.setState({
            showGroupingDialog: true
        })
    }

    handleGroupingTreeDialogClose = () => {
        this.setState({
            showGroupingDialog: false,
        })
    }

    handleSelectGroupingDialogSaveClose = (selectedGroupingObjArr) => {
        this.setState({
            showGroupingDialog: false,
            selectedGroupingObjArr: selectedGroupingObjArr
        })
    }

    
    handleAlertDialogCloseInfo = () =>{
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    // Debounce timers for city and country
    debounceTimers = {
        city: null,
        country: null
    };

    handleInputChange = (inputValue, { action, prevInputValue }, type = "") => {
        // type: 'city' or 'country' (passed from AsyncPaginate)
        this.setState({
            refreshKey: Date.now()
        });
        // No debounce logic here, just for compatibility
        return inputValue;
    };


    handleOnChangeCitySelectedOption = (item) => {
		this.setState({ 
			selectedItem:item,
			city:item.city_ascii,
            state:item.admin_name_ascii
        });
	}

    handleOnChangeCountrySelectedOption = (item) => {
        this.setState({ 
			selectedItem:item,
			country:item.country,
            city:"Search City",
            state:""
        });
    }

    /************************API CALLS **************************/
    addEditUnit = () => {
        this.setState({
            showLoader:true,
        });

        let isError = false;
        let FormErrorsTemp = {};

        if(isEmptyVariable(this.state.unitName.trim())){
            isError = true;
            FormErrorsTemp['unitName'] = "Please enter unit name";
        }

        if(isEmptyVariable(this.state.unitShortName.trim())){
            isError = true;
            FormErrorsTemp['unitShortName'] = "Please enter unit short name";
        }

        // if(isEmptyArray(this.state.tagsSelectedDD)){
        //     isError = true;
        //     FormErrorsTemp['functionList'] = "Please select function";
        // }

        if(isEmptyVariable(this.state.unitType) || this.state.unitType === unitTypePlaceholder){
            isError = true;
            FormErrorsTemp['unitType'] = "Please select unit type";
        }

        if(isEmptyVariable(this.state.address1.trim())){
            isError = true;
            FormErrorsTemp['address1'] = "Please enter address1";
        }

        if(isEmptyVariable(this.state.city)){
            isError = true;
            FormErrorsTemp['city'] = "Please enter city";
        }

        if(isEmptyVariable(this.state.state)){
            isError = true;
            FormErrorsTemp['state'] = "Please enter state";
        }

        if(isEmptyVariable(this.state.country)){
            isError = true;
            FormErrorsTemp['country'] = "Please enter country";
        }

        if(isError){
            this.setState({
                formErrors:FormErrorsTemp,
                showLoader:false
            });

            setTimeout(function(){
                this.setState({
                    formErrors:{},
                });
            }.bind(this),Constants.WRNG_MSG_TIMEOUT);
        }else{
            let url = Constants.CreateUnit
            if(this.props.isEdit){
                if(this.props.companyType === Constants.USER_ENGAGEMENT_TYPE_SELF && 
                    this.props.editUnitItem.parentUnit === "Y"){
                    url = Constants.EditCompany
                }else{
                    url = Constants.EditUnit
                }
            }
            let functionIds = [];
            this.state.tagsSelectedDD.map(item => {
                functionIds.push(item.value);
            })
            
            let postParam = {
                address1:this.state.address1,
                address2:this.state.address2,
                city:this.state.city,
                pinCode:this.state.pinCode,
                state:this.state.state,
                country:this.state.country,
                unitType:this.state.unitTypeShortName,
            }
            if(!isEmptyArray(this.state.selectedGroupingObjArr)){
                let unitGroupingIdList = [];
                this.state.selectedGroupingObjArr.map(item=>{
                    unitGroupingIdList.push({"unitGroupId":item?.unitGroupId,"rootUnitGroupId":item.rootUnitGroupId})
                })
                postParam.unitGroupingIdList = unitGroupingIdList
            }
            if(this.props.isEdit){
                if(this.props.companyType === Constants.USER_ENGAGEMENT_TYPE_SELF && 
                    this.props.editUnitItem.parentUnit === "Y"){
                    postParam.companyName = this.props.editUnitItem.companyName
                    postParam.companyShortName = this.props.editUnitItem.companyShortName
                    postParam.companyCode = this.props.editUnitItem.companyCode
                    postParam.companyId = this.props.editUnitItem.companyId
                }else{
                    postParam.unitName = this.state.unitName
                    postParam.unitShortName = this.state.unitShortName
                    postParam.companyId = this.props.editUnitItem.companyId
                }
                postParam.unitId = this.props.editUnitItem.unitId
            }else{
                //TODO hardcoded value must be removed
                postParam.companyId = this.props.companyId
                postParam.unitName = this.state.unitName
                postParam.unitShortName = this.state.unitShortName
                // postParam.companyId = 19
            }

            fetch(url,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    data:JSON.stringify(postParam),
                    // functions:JSON.stringify(functionIds)
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.setState({
                        showLoader:false,
                    },()=>{
                        this.props.handleAddUnitDialogClose(true)
                    });
                }else{
                    this.setState({
                        showLoader:false,
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage,
                    });
                }
            });
        }
    }

    getCitiesList = (inputValue) => {
        // Debounce logic for city
        clearTimeout(this.debounceTimers.city);
        return new Promise((resolve) => {
            // Prevent search if inputValue is empty (on dropdown click)
            if (!inputValue || inputValue.length < 3) {
                resolve({
                    options: [],
                    hasMore: false,
                    additional: { page: 1 }
                });
                return;
            }
            this.debounceTimers.city = setTimeout(() => {
                this.setState({ loading: true });
                fetch(Constants.Cities, {
                    method: "POST",
                    mode: "cors",
                    body: new URLSearchParams({
                        email: userDetails.email,
                        accessToken: userDetails.accessToken,
                        countryName: this.state.country,
                        cityName: inputValue
                    }),
                })
                .then((response) => response.json())
                .then((data) => {
                    if(handleTokenExpiry(data.responseCode)) {
                        resolve({ options: [] });
                        return;
                    }
                    else if (data.responseCode === Constants.CODE_SUCCESS) {
                        this.setState({
                            loading: false,
                            datalist: data.data.cities
                        });
                        resolve({
                            options: data.data.cities,
                            hasMore: false,
                            additional: { page: 1 }
                        });
                    } else {
                        this.setState({
                            showAlertDialogInfo:true,
                            alertDialogMessageInfo:data.responseMessage,
                            datalist: [],
                            loading: false,
                        });
                        resolve({ options: [] });
                    }
                })
                .catch(() => {
                    this.setState({
                        datalist:[]
                    });
                    resolve({ options: [] });
                });
            }, 2000); // 2 seconds debounce
        });
    };

    getCountryList = (inputValue) => {
        // Debounce logic for country
        clearTimeout(this.debounceTimers.country);
        return new Promise((resolve) => {
            // Prevent search if inputValue is empty (on dropdown click)
            if (!inputValue || inputValue.length < 3) {
                resolve({
                    options: [],
                    hasMore: false,
                    additional: { page: 1 }
                });
                return;
            }
            this.debounceTimers.country = setTimeout(() => {
                this.setState({ loading: true });
                fetch(Constants.Countries, {
                    method: "POST",
                    mode:'cors',
                    body: new URLSearchParams({
                        email:userDetails.email,
                        accessToken:userDetails.accessToken,
                        countryName:inputValue
                    })
                })
                .then(response => response.json())
                .then(data => {
                    if(handleTokenExpiry(data.responseCode)) {
                        resolve({ options: [] });
                        return;
                    }
                    else if(data.responseCode === Constants.CODE_SUCCESS){
                        this.setState({
                            loading: false,
                            datalist:data.data.countries
                        });
                        resolve({
                            options: data.data.countries,
                            hasMore: false,
                            additional: { page: 1 }
                        });
                    }else{
                        this.setState({
                            showAlertDialogInfo:true,
                            alertDialogMessageInfo:data.responseMessage,
                            datalist:[],
                            loading: false,
                        });
                        resolve({ options: [] });
                    }
                })
                .catch(() => {
                    this.setState({
                        datalist:[]
                    });
                    resolve({ options: [] });
                });
            }, 2000); // 2 seconds debounce
        });
    }
    /************************API CALLS END HERE**************************/

    render() {
        return(
            <div>
                <Modal className="add-unit-dialog custom-dialog" 
                show={this.props.showAddUnitDialog} backdrop="static">
                    <Modal.Header>
                        <h5>{this.props.isEdit?"Edit Unit":"Add New Unit"}</h5>
                        <button 
                            onClick={this.props.handleAddUnitDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        <div className="addnew-modal-form">
                            <div className="row custom-row">
                                <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group">
                                        <p>Unit Name*</p>
                                        <input 
                                            ref={this.textInput}
                                            type="text" 
                                            placeholder="Enter Unit Name" 
                                            name="unitName"
                                            onChange ={this.handleChange}
                                            value={this.state.unitName}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['unitName']) &&
                                            <span className="cm-error">{this.state.formErrors['unitName']}</span>
                                        }
                                        
                                    </div>
                                </div>
                                <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group">
                                        <p>Unit Short Name*</p>
                                        <input 
                                            type="text" 
                                            placeholder="Enter Unit Short Name" 
                                            name="unitShortName"
                                            onChange ={this.handleChange}
                                            value={this.state.unitShortName}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['unitShortName']) &&
                                            <span className="cm-error">{this.state.formErrors['unitShortName']}</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row custom-row">
                                <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group">
                                        <fieldset>
                                        <p>Unit Type*</p>
                                        <RegularDropdown 
                                            placeholder={this.state.unitType}
                                            dropdownArr={this.props.unitTypeArr}
                                            labelParam="name"
                                            onDropDownItemClick={this.typeDropdownClick}
                                            defaultPlaceholderDropDown={unitTypePlaceholder}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['unitType']) &&
                                            <span className="cm-error">{this.state.formErrors['unitType']}</span>
                                        }
                                        </fieldset>
                                    </div>
                                </div>
                                {hasFeatureAccess(Constants.FEATURE_BUSINESS_GROUPINGS) &&
                                    <div className="col-md-6 custom-col">
                                        <div className="addnew-modal-form-group">
                                            <p>Unit Grouping</p>
                                            <div 
                                                className="dummy-dropdown" 
                                                tabIndex={0} 
                                                onClick={this.handleSelectGroupingDialogShow}>
                                                    <p class="placeholder-text">
                                                        {isEmptyArray(this.state.selectedGroupingObjArr)
                                                        ?unitGroupingPlaceholderText
                                                        :this.state.selectedGroupingObjArr.length === 1
                                                        ?"1 Grouping Selected"
                                                        :this.state.selectedGroupingObjArr.length+" Grouping Selected"}
                                                    </p>
                                                    <span class="material-icons">keyboard_arrow_right</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {/* <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group">
                                        <p>Functions*</p>
                                        <CreatableSelect
                                            isMulti
                                            placeholder="Add Functions"
                                            styles={epicCustomStyles}
                                            classNamePrefix="dialog-react-select"
                                            value={this.state.tagsSelectedDD}
                                            onChange={this.handleTagChange}
                                            options={this.state.tagsMasterDD}
                                            // menuIsOpen={true}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['functionList']) &&
                                            <span className="cm-error">{this.state.formErrors['functionList']}</span>
                                        }
                                    </div>
                                </div> */}
                            </div>
                            <div className="row custom-row">
                                <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group">
                                        <p>Address Line 1*</p>
                                        <textarea 
                                            type="text" 
                                            placeholder="Enter Address Line 1" 
                                            name="address1"
                                            onChange ={this.handleChange}
                                            value={this.state.address1}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['address1']) &&
                                            <span className="cm-error">{this.state.formErrors['address1']}</span>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group">
                                        <p>Address Line 2</p>
                                        <textarea
                                            type="text" 
                                            placeholder="Enter Address Line 2" 
                                            name="address2"
                                            onChange ={this.handleChange}
                                            value={this.state.address2}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row custom-row">
                                <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group">
                                        <p>Country*</p>
                                        <AsyncPaginate
                                            value={{
                                                country:this.state.selectedCountryItem ? this.state.selectedCountryItem.country : this.state.country,
                                            }}
                                            loadOptions={this.getCountryList}
                                            defaultOptions={false}
                                            cacheOptions={false}
                                            cacheUniqs={[this.state.refreshKey]}
                                            onInputChange={(inputValue, meta) => this.handleInputChange(inputValue, meta, "country")}
                                            placeholder={this.state.country}
                                            getOptionLabel={(e) => e.country}
                                            getOptionValue={(e) => e.country}
                                            onChange={this.handleOnChangeCountrySelectedOption}
                                            noOptionsMessage={({ inputValue }) => inputValue && inputValue.length >= 3 ? "No Options" : null}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['country']) &&
                                            <span className="cm-error">{this.state.formErrors['country']}</span>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group">
                                        <p>City*</p>
                                        <AsyncPaginate
                                            value={{
                                                city_ascii:this.state.selectedCityItem ? this.state.selectedCityItem.city_ascii : this.state.city,
                                                admin_name_ascii:this.state.selectedCityItem ? this.state.selectedCityItem.admin_name_ascii : this.state.state,
                                            }}
                                            loadOptions={this.getCitiesList}
                                            defaultOptions={false}
                                            cacheOptions={false}
                                            cacheUniqs={[this.state.refreshKey]}
                                            onInputChange={(inputValue, meta) => this.handleInputChange(inputValue, meta, "city")}
                                            placeholder={this.state.city}
                                            getOptionLabel={(e) => e.city_ascii}
                                            getOptionValue={(e) => e.city_ascii}
                                            onChange={this.handleOnChangeCitySelectedOption}
                                            noOptionsMessage={({ inputValue }) => inputValue && inputValue.length >= 3 ? "No Options" : null}
                                            formatOptionLabel={(option, { context }) =>
                                                context === "menu"
                                                    ? `${option.city_ascii} (${option.admin_name_ascii})`
                                                    : option.city_ascii
                                            }
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['city']) &&
                                            <span className="cm-error">{this.state.formErrors['city']}</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row custom-row">
                                <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group input-dis">
                                        <p>State*</p>
                                        <input
                                            type="text" 
                                            placeholder="Enter State" 
                                            name="state"
                                            onChange ={this.handleChange}
                                            value={this.state.state}
                                            disabled={true}
                                        />
                                        {
                                            !isEmptyVariable(this.state.formErrors['state']) &&
                                            <span className="cm-error">{this.state.formErrors['state']}</span>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6 custom-col">
                                    <div className="addnew-modal-form-group input-dis">
                                        <p>Pin Code</p>
                                        <input
                                            type="text" 
                                            placeholder="Enter Pin Code" 
                                            name="pinCode"
                                            onChange ={this.handleChange}
                                            value={this.state.pinCode}
                                        />
                                    </div>
                                </div>
                                {/* {
                                    !isEmptyVariable(this.state.formErrors['responseMessage']) &&
                                    <span className="cm-error">{this.state.formErrors['responseMessage']}</span>
                                } */}
                            </div>
                        </div>
                        
                        <div className="modal-close-save">
                            <div className="close-save-col">
                                <button onClick={this.props.handleAddUnitDialogClose} type="button" className="modal-close">Cancel</button>
                                <DialogSaveButton themeSettings={this.props.themeSettings} onClick={this.addEditUnit} type="button" className="modal-save">
                                    {this.state.showLoader ? <div class="loader-btn mt-2"></div> : 'Save'}
                                </DialogSaveButton>
                            </div>
                        </div>
                    </div>
                </Modal>
                <AddCityDialog
                    showAddCityDialog = {this.state.showAddCityDialog}
                    handleCityDialogClose = {this.handleSearchCityDialogClose}
                    themeSettings={this.props.themeSettings}
                    isEdit={this.state.isEdit}
                    selectedCity={this.state.city}
                />
                <SelectGroupingDialog
                    showGroupingDialog={this.state.showGroupingDialog}
                    handleGroupingDialogClose={this.handleGroupingTreeDialogClose}
                    handleSelectGroupingDialogSaveClose={this.handleSelectGroupingDialogSaveClose}
                    themeSettings={this.props.themeSettings}
                    isClient={"N"}
                    companyId={this.props.companyId}
                    companyType={this.props.companyType}
                    selectedGroupingObjArr={this.state.selectedGroupingObjArr}
                />
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type= {Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={this.props.themeSettings}
                />
            </div>
        );
    }
}

export default AddUnitDialog;